import Box from '@mui/material/Box';
import '../../App.css';
import '../../style.css';
import {
  DIRECTIONAL_PAD_ROOT_BOX_SX      ,
  DIRECTIONAL_PAD_UP_BUTTON_SX     ,
  DIRECTIONAL_PAD_LEFT_BUTTON_SX   ,
  DIRECTIONAL_PAD_RIGHT_BUTTON_SX  ,
  DIRECTIONAL_PAD_DOWN_BUTTON_SX   ,
  DIRECTIONAL_PAD_CENTER_BUTTON_SX , } from '../Style/GBDirectionalPadStyle';

function DirectionalPadKey({
  label,
  onClick,
  onUp,
  onDown,
  onLeft,
  onRight,
}) {
  // 上ボタンクリック時の処理
  const handleClickUPButton = () => {
    console.log('うえボタン');
    if (onUp) onUp();
    if (onClick) onClick('up');
  };

  // 下ボタンクリック時の処理
  const handleClickDownButton = () => {
    console.log('したボタン');
    if (onDown) onDown();
    if (onClick) onClick('down');
  };

  // 左ボタンクリック時の処理
  const handleClickLeftButton = () => {
    console.log('ひだりボタン');
    if (onLeft) onLeft();
    if (onClick) onClick('left');
  };

  // 右ボタンクリック時の処理
  const handleClickRightButton = () => {
    console.log('みぎボタン');
    if (onRight) onRight();
    if (onClick) onClick('right');
  };

  return (
    <Box sx={DIRECTIONAL_PAD_ROOT_BOX_SX}>
      {/* 十字キー(上ボタン) */}
      <Box onClick={handleClickUPButton} sx={DIRECTIONAL_PAD_UP_BUTTON_SX}>
        ▲
      </Box>

      {/* 十字キー(左ボタン) */}
      <Box onClick={handleClickLeftButton} sx={DIRECTIONAL_PAD_LEFT_BUTTON_SX}>
        ▲
      </Box>

      {/* 十字キー(右ボタン) */}
      <Box
        onClick={handleClickRightButton}
        sx={DIRECTIONAL_PAD_RIGHT_BUTTON_SX}
      >
        ▲
      </Box>

      {/* 十字キー(下ボタン) */}
      <Box
        onClick={handleClickDownButton}
        sx={DIRECTIONAL_PAD_DOWN_BUTTON_SX}
      >
        ▼
      </Box>

      {/* 十字キー(中央) */}
      <Box sx={DIRECTIONAL_PAD_CENTER_BUTTON_SX}>●</Box>
    </Box>
  );
}

export default DirectionalPadKey;
